import './Footer.css'
const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p>copyright 2022 <a>cyborg gaming</a> company. all rights reserved. <br/> design: <a>walaa horani</a></p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer